(function () {

    "use strict";
    function headappController($scope, $rootScope, $mdSidenav, usersStore, loginService) {
        var vm = this;

        if (!$rootScope.user) {
            $rootScope.user = {};
        }
        $scope.showMobileMainHeader = true;
        $scope.openSideNavPanel = function () {
            $mdSidenav('left').open();
            /*Scroll to top*/

            var scrollDuration = 100;
            var scrollStep = -window.scrollY / (scrollDuration / 15);

            var scrollInterval = setInterval(function () {
                if (window.scrollY !== 0) {
                    window.scrollBy(0, scrollStep);
                } else {
                    clearInterval(scrollInterval);
                }
            }, 15);
        };

        vm.breadcrumb = {
            items:
                [{
                    text: "Inicio",
                    action: null
                }
                ]
        };

        $rootScope.breadcrumb = vm.breadcrumb;

        vm.breadcrumbAction = function (item) {
            item.action();
        };

        vm.exitLogin = function () {
            loginService.logout();
        };

        vm.obtenerDatosUser = function () {
            usersStore.getLoggedUserData()
                .then(function (user) {
                    vm.user = user;
                });
        };

        vm.obtenerDatosUser();

    }

    headappController.$inject = ["$scope", "$rootScope", "$mdSidenav", "sphForms.usersStore", "sphForms.loginService"];

    angular.module("sphforms.main")
        .component("sphFormsHeadApp", {
            controller: headappController,
            templateUrl: "modules/main/components/menus/headapp/headapp.template.html"
        });

}());


